import { observer } from 'mobx-react-lite'
import React, { FC, Suspense, useEffect } from 'react'
import { Route, Routes, useLocation } from 'react-router-dom'
import { publicRoutes } from '../core/router'

import { Loader } from './Loader'

const AppRouter: FC = () => {
	const location = useLocation()

	useEffect(() => {
		window.scrollTo({ top: 0, left: 0 })
		document.getElementById('root')?.scrollTo({ top: 0, left: 0 })
	}, [location.pathname])

	return (
		<Suspense fallback={<Loader />}>
			<Routes>
				{publicRoutes.map((route) => (
					<Route path={route.path} element={route.component} key={route.path} />
				))}
			</Routes>
		</Suspense>
	)
}

export default observer(AppRouter)
